import React from "react";
import { Button,Modal } from 'antd';
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import NHFetch from "../../../utils/NHFetch";
import moment from 'moment';

/**
 * 环节办理业务项查询列表
 * @author Xiafanglin
 * @date 2018-03-21 02:13:57
 * Version: 1.0
 */
class HjblywxIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
            },
            dmkmcList:{},
            previewVisible: false,
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //导出Excel文件  
    handleExportBtnClick = () => {
        this.refs.nhTable.exportExcel("导出环节业务项办理数据");
    };

    //获取下拉列表value对应的名称
    getDmkMc = (dmbz, zdbz) => { 
        NHFetch("/proData/selectDataList", "GET", { sign: dmbz })
            .then(res => { 
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }
      //获取联级下拉列表value对应的名称
    getCascaderDmkMc = (level,sign, cascaderValue,zdbz) => { 
        NHFetch("/proData/selectCascaderList", "GET", { level:level,sign: sign ,cascaderValue:cascaderValue})
            .then(res => {  
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[level+zdbz] = res.data; 
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }
    // 点击文件链接或预览图标时的回调
    handlePreview = (fjmc, fjid) => { 

        if (fjmc==="isImage") {
            this.showPreview(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        }
    };

    //打开图片弹窗
    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }
    // 关闭图片弹窗
    closeModal = () => this.setState({ previewVisible: false });
    // 文件展示 
    fileLists = (fileLists) => {
            {
                let items=[];
                for(let key in fileLists){
                    let fileList = typeof fileLists[key] == 'string'?fileLists[key].split(";"):fileLists[key]; 
                    items.push (
                        <div >
                            <a onClick={() => {
                             this.handlePreview("file",fileList[0]);
                            }}>{fileList[1]}</a> 
                        </div>
                    )
                }
            return items;
            }
        };
    //图片展示
    imageLists = (imageLists) =>{
        {
            let items=[];
            for(let key in imageLists){
                let imageList = typeof imageLists[key] == 'string'?imageLists[key].split(";"):imageLists[key];
                items.push (
                    <span>
                       <img style={{height:"80px" ,width:"80px"}} src={"anonymity/docrepo/download/file?attachmentId=" + imageList}
                        onClick={() => {
                            this.handlePreview("isImage",imageList[0]);
                        }}/>
                    </span>
                )
            }
            return items;
        }
    }

    render() {

        const { valiteColumns,previewVisible,previewImage  } = this.state;

        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '51px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                search: 'input',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '91px',
                search: 'input',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '72px',
                search: 'input',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '学生类别',
                width: '100px',
                search: 'input',
                dataIndex: 'XSLB',
                searchType:"select"
            }, {
                title: '校区',
                width: '101px',
                search: 'input',
                dataIndex: 'XQMC',
                searchType:"input"
            }, {
                title: '院系',
                width: '200px',
                search: 'input',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                search: 'input',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '200px',
                search: 'input',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '环节名称',
                width: '120px',
                search: 'input',
                dataIndex: 'HJMC',
                searchType:"select"
            }, {
                title: '业务项名称',
                width: '120px',
                search: 'input',
                dataIndex: 'ZDMC',
                searchType:"select"
            }, {
                title: '字段值',
                width: '100px',
                search: 'input',
                dataIndex: 'YWXZMC',
                render: (text, record) => {
                    console.info("渲染========");
                    console.info(record);
                    const {KJCS,YWXZ,ZDBZ} = record;
                    console.info("~~~~~~~~~~~~~~~~~~~");
                    console.info("KJCS++++"+KJCS);
                    console.info("YWXZ++++"+YWXZ);
                    console.info("ZDBZ++++"+ZDBZ);
                    console.info("record[ZDBZ];"+record[ZDBZ]);
                    let zdz = YWXZ;
                    let kjcsjson = JSON.parse(KJCS);
                    let zdzmc = '';
                    if(kjcsjson.type === 'datepicker'||kjcsjson.type === 'datetimepicker'||kjcsjson.type === 'timepicker'||kjcsjson.type === 'monthpicker'||kjcsjson.type === 'rangepicker'){    //日期值展示阶段，从moment转为文字 
                        console.info("时间渲染=======");
                        console.info(zdz);
                        if(YWXZ){
                            zdzmc=moment(YWXZ).format(kjcsjson.format);
                        console.info("转义之后！！");
                        console.info(zdzmc);
                        }
                    } else if (kjcsjson.type === "multiselect") { 
                        if (kjcsjson.dataTag && !this.state.dmkmcList[YWXZ]) {
                            this.getDmkMc(kjcsjson.dataTag, YWXZ);
                        }
                        let list = this.state.dmkmcList[YWXZ]; 
                        if(YWXZ){ 
                            let multiselect=typeof YWXZ == 'string'?YWXZ.split(","):YWXZ;    
                            let multiselectList=[];
                            for(let i in multiselect){
                                list && list.map(item => {
                                    if (item.VALUE === multiselect[i]) {
                                        multiselectList.push(item.LABEL);
                                    }
                                })
                            }
                            zdzmc=multiselectList.join(",");
                     }
                    }else if (kjcsjson.type === "nhcascader") {   
                        if(YWXZ){ 
                            let nhcascaderList=typeof YWXZ == 'string'?YWXZ.split(","):YWXZ;     
                            let nhcascaderLists=[];    
                            console.info("nhcascaderList+++"+nhcascaderList);
                            for(let i in nhcascaderList){  
                                let level=i;
                                let c=i;
                                let d=i;
                                let a=++level;
                                let b=--d;
                                if (kjcsjson.dataTag && !this.state.dmkmcList[a+YWXZ] ) {
                                    if(i == "0"){
                                        this.getCascaderDmkMc(a,kjcsjson.dataTag,'',YWXZ) 
                                    }
                                    else{
                                        this.getCascaderDmkMc(a, kjcsjson.dataTag,nhcascaderList[b],YWXZ) 
                                    } 
                                }
                                    let list=this.state.dmkmcList[level+++YWXZ];
                                    
                                    list && list.map(item => {   
                                        if (item.value === nhcascaderList[c]) { 
                                            nhcascaderLists.push(item.label);
                                        }
                                    }) 
                            }
                            zdzmc=nhcascaderLists.join("/");
                        }
                     }else if(kjcsjson.type === "switch"){
                       
                        zdzmc = (YWXZ === "1" || YWXZ === true || YWXZ === "true" ) ? kjcsjson.checkedText:kjcsjson.uncheckedText;
                    } else if(kjcsjson.type === "radio"){
                        kjcsjson.options&&kjcsjson.options.map((item,key)=>{
                            if(item.value === YWXZ){
                                zdzmc = item.label;
                            }
                        })
                    }else if(kjcsjson.fileType === "file" && YWXZ  ){  
                        let fileLists=typeof YWXZ == 'string'?YWXZ.split(","):YWXZ;   
                        zdzmc=(
                            this.fileLists( fileLists)  
                        )
                    }else if(kjcsjson.fileType === "image" && YWXZ ){    
                        if (typeof YWXZ === 'object') { 
                            let array = [];
                            for (let item of YWXZ) {
                                if (item.hasOwnProperty('uuid') && item['uuid']) {
                                    array.push(item['uuid']) 
                                }
                            }
                            zdz= array
                        }else{
                            zdz=zdz.split(",");
                        } 
                        zdzmc=(
                            this.imageLists(zdz)  
                        )  
                    } 
                        else {
                            zdzmc = zdz;
                        }
                    return zdzmc;
                }



                // render:(text,record)=>{
                //     const {KJCS,YWXZ,ZDBZ} = record;
                //     if(YWXZ === null){
                //         return null;
                //     }
                //     let kjcsjson = JSON.parse(KJCS);
                //     let zdzmc = '';
                //     if (kjcsjson.type === "select") {
                //         if (kjcsjson.dataTag && !this.state.dmkmcList[ZDBZ]) {
                //             this.getDmkMc(kjcsjson.dataTag, ZDBZ);
                //         }
                //         let list = this.state.dmkmcList[ZDBZ];
                //         list && list.map(item => {
                //             if (item.VALUE === YWXZ) {
                //                 zdzmc = item.LABEL;
                //             }
                //         })
                //     }else 
                //     if(kjcsjson.type === "switch"){
                //         zdzmc = (YWXZ =="true" || YWXZ == "1" || YWXZ == true )? kjcsjson.checkedText:kjcsjson.uncheckedText;
                //     } 
                //     else if(kjcsjson.type === "radio"){
                //         kjcsjson.options&&kjcsjson.options.map((item,key)=>{
                //             if(item.value === YWXZ){
                //                 zdzmc = item.label;
                //             }
                //         })
                //     }
                //     else {
                //         zdzmc = YWXZ;
                //     }
                //     return zdzmc;
                // }
                
            }
        ];
        //行内操作

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none' }}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_tjcx_hjblywxcx_queryPage"}
                        columns={columns}
                        sqlParams={{ywxSign:'zhxg_yx_lcgl_ywxdy'}}
                        rangeFilter={true}
                    >
                    <Button type="primary" ghost style={{marginLeft: 10}} onClick={this.handleExportBtnClick}>导出</Button>
                    </NHTable>
                </div>
                <Modal
                        visible={previewVisible}
                        footer={null}
                        onCancel={this.closeModal}
                    >
                        <img
                            alt="example"
                            style={{ width: '100%' }}
                            src={previewImage}
                        />
                    </Modal>
            </div>
        );
    }
}
export default HjblywxIndex;



// WEBPACK FOOTER //
// ./components/tjcx/hjblywxcx/index.js